import { useState } from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import InfoAlert from 'src/components/InfoAlert';
import { readFilterParams, useFilterParams } from 'src/hooks/filterParams';
import TelemetryDevicesModal from './TelemetryDevicesModal';
import TelemetryFilesTable from './TelemetryFilesTable';
import {
  DEFAULT_TELEMETRY_FILTERS,
  TELEMETRY_FILTER_OPTIONS,
  withReportedWindow,
} from './constants';

const TelemetryTab = () => {
  const { appId } = useParams();
  const [devicesOpen, setDevicesOpen] = useState(false);
  const [filters, setFilters] = useState(() =>
    withReportedWindow(
      readFilterParams(DEFAULT_TELEMETRY_FILTERS, TELEMETRY_FILTER_OPTIONS) ??
        DEFAULT_TELEMETRY_FILTERS,
    ),
  );

  useFilterParams(filters);

  return (
    <Stack gap={2}>
      <InfoAlert>
        <Typography variant="body2" sx={{ color: 'inherit', fontSize: '0.8125rem' }}>
          <Box component="span" sx={{ fontWeight: 700 }}>
            How to read this:
          </Box>{' '}
          These are the files devices reported for this app over the last 90 days, or since its
          status was last updated with that filter checked. Import ones that belong but aren&apos;t
          covered, and deploy your latest policy for the ones that are. See the WDAC impacted
          devices{' '}
          <Link
            component="button"
            type="button"
            onClick={() => setDevicesOpen(true)}
            underline="always"
            sx={{
              fontWeight: 700,
              color: '#BEEBFF',
              textDecorationColor: '#BEEBFF',
              verticalAlign: 'baseline',
            }}>
            here
          </Link>
          .
        </Typography>
      </InfoAlert>

      <TelemetryFilesTable
        globalApplicationVersionId={appId}
        filters={filters}
        onFiltersChange={setFilters}
      />

      <TelemetryDevicesModal
        open={devicesOpen}
        onClose={() => setDevicesOpen(false)}
        globalApplicationVersionId={appId}
      />
    </Stack>
  );
};

export default TelemetryTab;
